'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$40(outer) {
  this.aYu = null;
  this.aYs = null;
  this.aYt = false;
  this.aYq = null;
  this.aYr = false;
  this.aYv = false;
  this.aYw = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aYu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_GroupsView$$anon$40 as $c_Lpresto_GroupsView$$anon$40 };
$p = $c_Lpresto_GroupsView$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$40;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$40() {
}
export { $h_Lpresto_GroupsView$$anon$40 as $h_Lpresto_GroupsView$$anon$40 };
$h_Lpresto_GroupsView$$anon$40.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aYu;
});
$p.t = (function() {
  if ((!this.aYt)) {
    this.aYs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("blocked", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aYt = true;
  }
  return this.aYs;
});
$p.ae = (function() {
  if ((!this.aYr)) {
    this.aYq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().iZ, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aYr = true;
  }
  return this.aYq;
});
$p.w = (function() {
  if ((!this.aYw)) {
    this.aYv = false;
    this.aYw = true;
  }
  return this.aYv;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_GroupsView$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$40, "presto.GroupsView$$anon$40", ({
  JV: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$40 as $d_Lpresto_GroupsView$$anon$40 };
//# sourceMappingURL=presto.-Groups-View$$anon$40.js.map
